/*global $:false */

import SearchM from './recordm.model.search.js';

//Model responsible for executing simple searches
var SimpleSearchM = function(core) {
    this._core = core;
    this._filters = []

    /* eslint-disable-next-line prefer-rest-params  */
    SearchM.apply(this, arguments);
};

SimpleSearchM.prototype = new SearchM();
SimpleSearchM.prototype.constructor = SimpleSearchM;
SimpleSearchM.prototype._name = 'SimpleSearchM';


SimpleSearchM.prototype.setFilters = function(filters){
    this._filters = filters || []
};

SimpleSearchM.prototype.getFilters = function(){
    return this._filters
};

SimpleSearchM.prototype.setQueryFilter = function(esQuery) {
    this.setCurrentFilter(esQuery);
};

// ## Private Helpers

/*
 * Private method that executes a search
 * opts:
 * *`refresh`: parameter indicates whether it's a refresh search action or not
 * *`onSearchDone`: the callback to invoke after the search is done
 * *`eventId`: (OPTIONAL) the search request identifier in order to be able to perform
 * multiple searches in different modules at the same time
 */
SimpleSearchM.prototype._executeSearch = function(opts) {
    var _this = this,
        from = opts && opts.refresh ? 0 : this._from,
        rowsToFetch = opts && opts.size ? opts.size : this._rowsPerPage,
        searchResults = [],
        eventId = opts && opts.eventId ? opts.eventId : "";

    if (opts && opts.refresh && this._searchResults.length > this._rowsPerPage) {
        rowsToFetch = this._searchResults.length;
    }

    $.ajax({
        url: this._buildSearchUrl(this.getCurrentQuery(), from, rowsToFetch, this._sortField, this._sortAsc),
        type: 'GET',
        contentType: "application/json",
        success: function(data) {

            if (opts && opts.refresh) {
                _this._clearSearchResults();
            }

            _this._totalMatchingInstances = data.hits.total.value;
            _this._storeResults(data);

            searchResults = _this._searchResults;

            if (opts && typeof opts.onSearchDone === 'function') {
                opts.onSearchDone()
            }
        },
        error: function(req) {
            window.console.log("SEARCH:ERROR: " + req.status + " : " + req.statusText + ":" + req.responseText);
            _this._core.publish('recordm:search:error' + eventId, {errorCode: req.status});
        },
        complete: function() {
            _this._core.publish('recordm:search:finished' + eventId, {simpleSearch: true, searchResults: searchResults});
        }
    });
};

// Private helper that builds a search string
SimpleSearchM.prototype._buildSearchUrl = function(query, from, rowsToFetch, sortField, sortAsc) {
    var endpointUrl = this.searchurl;

    endpointUrl += '?q=' + encodeURIComponent(query || "*") +
                   '&from=' + (from) +
                   '&size=' + rowsToFetch;

    endpointUrl += `&tz=${Intl.DateTimeFormat().resolvedOptions().timeZone}`;

    if (sortField) {
        endpointUrl += "&sort=" + sortField +
                       "&ascending=" + sortAsc;
    }

    return endpointUrl;
};

export default SimpleSearchM;
